import React from 'react';

interface LogoProps {
  className?: string;
  variant?: 'horizontal' | 'vertical';
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  variant = 'horizontal',
  showText = true 
}) => {
  return (
    <div className={`flex ${variant === 'vertical' ? 'flex-col' : 'flex-row'} items-center ${className} group`}>
      {/* Logo Mark */}
      <div className="relative">
        <img 
          src="https://i.imgur.com/yJNW8lN.png"
          alt="United eLoans Logo"
          className={`${variant === 'vertical' ? 'w-24 h-24 mb-4' : 'w-16 h-16 mr-4'} transform transition-transform duration-500 group-hover:scale-105 object-contain`}
        />
      </div>

      {/* Text Elements */}
      {showText && (
        <div className={`flex flex-col ${variant === 'vertical' ? 'text-center' : 'text-left'}`}>
          <span className="text-3xl font-bold tracking-tight bg-gradient-to-r from-brand-red to-brand-blue bg-clip-text text-transparent transform transition-all duration-500">
            United eLoans
          </span>
          {variant === 'horizontal' && (
            <div className="flex items-center space-x-2">
              <span className="h-px w-8 bg-gradient-to-r from-brand-red to-transparent" />
              <span className="text-sm font-medium text-brand-blue/80">
                Trusted Financial Solutions
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;